'use client'

import { useEffect, Suspense } from "react"
import { signIn } from "next-auth/react"
import { useSearchParams } from "next/navigation"

// 1. Creamos un componente interno que maneja la lógica de los parámetros
function LoginHandler() {
    const searchParams = useSearchParams()
    const callbackUrl = searchParams.get("callbackUrl") || "/gestion"

    useEffect(() => {
        signIn("keycloak", { callbackUrl })
    }, [callbackUrl])

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'sans-serif', backgroundColor: '#f9f9f9' }}>
            <div style={{ textAlign: 'center' }}>
                <p style={{ color: '#666', fontSize: '16px' }}>Cargando portal de seguridad...</p>
            </div>
        </div>
    )
}

// 2. Exportamos la página principal envuelta en Suspense
export default function LoginPage() {
    return (
        <Suspense fallback={
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'sans-serif', backgroundColor: '#f9f9f9' }}>
                <div style={{ textAlign: 'center' }}>
                    <p style={{ color: '#666', fontSize: '16px' }}>Preparando entorno...</p>
                </div>
            </div>
        }>
            <LoginHandler />
        </Suspense>
    )
}